import 'lazyload/lazyload.min.js';
import Headroom from 'headroom.js';
import Swiper from 'swiper';

const common = function () {
  console.log('hello from common');

  setTimeout(function () {
    setupHeader();
    setupBarbaContainer();
    setupNavModal();
    setupLauftextSwiper();
    $('img.lazyload').lazyload();
  }, 500);

  $(window).on('resize', function () {
    setupBarbaContainer();
  });

  function setupHeader() {
    $('.hamburger.toggle-nav').unbind();
    $('.hamburger.toggle-nav').on('click', function () {
      $('.hamburger.toggle-nav').toggleClass('is-active');
    });

    const header = document.querySelector('header');
    const headroom = new Headroom(header);
    headroom.init();
  }

  function setupBarbaContainer() {
    let headerHeight = $('header.banner').innerHeight();
    if ($('.container.barba').hasClass('y-shifted')) {
      $('.container.barba.y-shifted').css(
        'padding-top',
        headerHeight - headerHeight / 2
      );
    } else {
      $('.container.barba').css('padding-top', headerHeight);
    }

    $('.container.barba').css(
      'padding-bottom',
      $('footer.content-info').outerHeight()
    );
    $('.container.barba footer.content-info').css('opacity', 1);
  }

  function setupNavModal() {
    $('#nav-modal a').unbind();
    $('#nav-modal a').click(function () {
      $('#nav-modal').modal('hide');
      $('.hamburger.toggle-nav').removeClass('is-active');
    });

    $('#nav-modal').on('hidden.bs.modal', function (e) {
      $('.hamburger.toggle-nav').removeClass('is-active');
    });
  }


  function setupiFrame() {
    let $iframeScript = $('.iframe-script');
    
    if($iframeScript) {
      console.log('setupiFrame');
      // let script = document.createElement('script');
      // script.type = 'text/javascript';
      // script.src = 'https://unpkg.com/smg-layout-solution-loader@1.0/iframeResizer.min.js';
      // document.body.appendChild(script);

      // let script2 = document.createElement('script');
      // script2.type = 'text/javascript';
      // script2.src = 'https://unpkg.com/smg-layout-solution-loader@1.0/layoutSolutionLoader.js';
      // script2.setAttribute('data-language', 'de');
      // script2.setAttribute('data-offerType', '');
      // script2.setAttribute('data-agencyId', 'isx15599');
      // script2.setAttribute('data-provider', 'is24');
      // script2.setAttribute('data-primaryColor', '00b27a');
      // script2.setAttribute('data-primaryTextColor', 'ffffff');
      // script2.setAttribute('data-hideSearchBar', 'true');
      // setTimeout(function () {
      //   $iframeScript.append(script2);
      // }, 500);

      // $('#layout-solution-loader').attr('src',$('#layout-solution-loader').attr('data-src'));


    }
  }
  setupiFrame();

  function setupLauftextSwiper() {
    const lauftextSliderList = $('.swiper-container.lauftext');

    if (lauftextSliderList.length) {
      lauftextSliderList.each( function( i ) {

        // Swiper for flexible content
        let lauftextSwiper = new Swiper(this, {
          speed: 400,
          spaceBetween: 15,
          slidesPerView: 1,
          loop: true,
          init: true,
          autoHeight: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
          },
          lazy: {
            loadPrevNext: true,
          },
        });
  
        lauftextSwiper.update();
      });
    }

  }


};

export default common;



// WEBPACK FOOTER //
// ./scripts/barba-views/common.js